import React, { useState, useCallback } from 'react';
import { useWindowWidth } from '@react-hook/window-size/throttled';

import CopyText from '../CopyText';
import Icon from 'components/ui/Icon';

const Dropdown = ({ sources, publicDate }) => {
  const [openAcc, setOpenAcc] = useState(false);
  const windowWidth = useWindowWidth({ initialWidth: 640 });

  const handleOpenMenu = useCallback(() => {
    setOpenAcc(!openAcc);
  }, [openAcc]);

  return (
    <div className="">
      <div className="flex justify-between items-center">
        {sources ? (
          <button
            type="button"
            onClick={handleOpenMenu}
            className="oc-small flex items-center uppercase outline-none"
          >
            Sources
            <Icon
              name="dropdown"
              className={`w-7 h-7 sm:w-9 sm:h-9 transition-transform ${
                openAcc && 'transform rotate-180'
              }`}
            />
          </button>
        ) : null}

        {windowWidth > 640 && <CopyText publicDate={publicDate} />}
      </div>
      {openAcc ? <div className="pt-4 sm:pt-5 oc-small"> {sources}</div> : null}
    </div>
  );
};

export default Dropdown;
